import type { Resource } from '../../';
export const forms_field_enterEmail: Resource = {"default":"Enter Your Email Address"};
